/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFaceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-face"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.95 14.3Q8.95 14.3 8.68 14.3Q8.4 14.3 8.03 13.93Q7.65 13.55 7.65 13Q7.65 12.45 8.03 12.07Q8.4 11.7 8.95 11.7Q9.5 11.7 9.88 12.07Q10.25 12.45 10.25 13Q10.25 13.55 9.88 13.93Q9.5 14.3 8.95 14.3ZM15.05 14.3Q15.05 14.3 14.78 14.3Q14.5 14.3 14.13 13.93Q13.75 13.55 13.75 13Q13.75 12.45 14.13 12.07Q14.5 11.7 15.05 11.7Q15.6 11.7 15.97 12.07Q16.35 12.45 16.35 13Q16.35 13.55 15.97 13.93Q15.6 14.3 15.05 14.3ZM12 20.15Q15.4 20.15 17.77 17.77Q20.15 15.4 20.15 12Q20.15 11.4 20.07 10.81Q20 10.22 19.8 9.7Q19.27 9.82 18.73 9.89Q18.18 9.95 17.6 9.95Q15.3 9.95 13.24 8.96Q11.18 7.97 9.7 6.2Q8.9 8.18 7.39 9.65Q5.88 11.13 3.85 11.85Q3.85 11.9 3.85 11.93Q3.85 11.95 3.85 12Q3.85 15.4 6.22 17.77Q8.6 20.15 12 20.15ZM12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.79Q2.9 5.83 4.36 4.36Q5.83 2.9 7.79 2.05Q9.75 1.2 12 1.2Q14.25 1.2 16.21 2.05Q18.18 2.9 19.64 4.36Q21.1 5.83 21.95 7.79Q22.8 9.75 22.8 12Q22.8 14.25 21.95 16.21Q21.1 18.18 19.64 19.64Q18.18 21.1 16.21 21.95Q14.25 22.8 12 22.8Z" fill={color} />
    </svg>
  );
}
